import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import SegmentSummaryTable from '../../corrCluster/Cluster/SegmentSummaryTable';

const GenericBasicTableCellContent = ({
  rowHeader,
  rowData,
  isSegmentSummaryTable,
  handleContentScroll,
 }) => {
  return (
    <Fragment>
      {isSegmentSummaryTable &&
        <SegmentSummaryTable
          data-test="genericBasicTableCellContentComponent"
          rowHeader={rowHeader}
          rowData={rowData}
          handleContentScroll={handleContentScroll}
        />}
    </Fragment>
  );
};

GenericBasicTableCellContent.propTypes = {
  rowData: PropTypes.arrayOf(PropTypes.object),
  rowHeader: PropTypes.arrayOf(PropTypes.string),
  isSegmentSummaryTable: PropTypes.bool,
  handleContentScroll: PropTypes.func,
};

export default GenericBasicTableCellContent;
